import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import {
    IApplicationState, AppActionCreators, IAppState, IDiagnosticResponse, DashCenterActionCreators, IDiagnosticLookupDataResponse
} from '@nkr/store/index';
import { IBaseResponse, ICenterBase, IExistingRegistration, IListItem, IDonorDiagnosticRequest } from '@nkr/models/index';
import { DashRegistrationStep } from '@nkr/enums/index';
import { Button, Col, ControlLabel, FormControl, FormGroup, InputGroup, Label, Panel, PanelGroup, Radio, Row } from 'react-bootstrap';
import { DiagnosticsFormWrapper, FormWrapper } from '../styles';
import { toast } from 'react-toastify';
import ConfirmRuleOut from './confirm-rule-out';
import { IStateCenterOption } from '@nkr/store/donor-intake/actions';

interface IProps {
    regId: number,
    centerId: number,
    isAdmin: boolean,
    isConfirm: boolean,
    previousUrl: string,
    previousName: string
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getDiagnostic: (centerId: number, registrationId: number, isAdmin: boolean) => Promise<IDiagnosticResponse>,
    getLookupData: () => Promise<IDiagnosticLookupDataResponse>,
    saveDiagnostic: (request: IDonorDiagnosticRequest) => Promise<IDiagnosticResponse>,
    optInToMentor: (registrationId: number) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IValidation {
    entryDomain: boolean,
    closeLoopSurgeryDateTime: boolean,
    birthDate: boolean,
    email: boolean,
    mobileAuthPhone: boolean
}

interface IState {
    id: number,
    centerId: number,
    email: string,
    firstName: string,
    middleInitial: string,
    lastName: string,
    preferredName: string,
    donationType: number,
    entryDomain: string,
    currentRegistrationStep: number,
    isAcceptable: boolean,
    ruleOutReasons: string,
    sendReScreen: boolean,
    editKey: string,
    stopCommunication: boolean,
    connectToDonorIsDesired: boolean,
    connectToDonorGroup: number,
    closeLoopSurgeryDateTime: string,
    isCurrentlyIncarcerated: boolean,
    isResidingInUsa: boolean,
    isAbleToGetToUsa: boolean,
    isDonatingForCompensation: boolean,
    willAcceptTransfusions: boolean,
    hasHadKidneyDisease: boolean,
    hasHadHeartAttack: boolean,
    hasDiabetes: boolean,
    diabetesStatus: number,
    hasHadCancer: boolean,
    hasHadKidneyStones: boolean,
    kidneyStoneEpisodes: number,
    kidneyStoneRemissionStatus: number,
    hasBeenPregnant: boolean,
    isPregnant: boolean,
    monthsSincePregnant: number,
    isNursing: boolean,
    hadGestationalDiabetes: boolean,
    hasUsedTobacco: boolean,
    usesTobacco: boolean,
    willStopTobaccoUse: boolean,
    hasHiv: number,
    weightLbs: number,
    heightInches: number,
    birthDate: string,
    addressLine1: string,
    city: string,
    state: number,
    nonUsStateProvince: string,
    countryOfResidenceId: number | null,
    postalCode: number,
    donorSituation: number,
    ddRecipFirstName: string,
    ddRecipLastName: string,
    ddRecipDob: string,
    preWorkupLabStep: number,
    phoneNumber: string,
    phoneNumberSecondary: string,
    mobileAuthPhone: string,
    expireDateTime: string,
    isMobileAuthPhoneConfirmed: boolean,
    originalMobileAuthPhone: string,
    isConfirm: boolean,
    originalEmail: string,
    validation: IValidation,
    previousLocation: string,
    originalCenterId: number,
    intendedRecipientCenter: number | null,
    existingList: IExistingRegistration[],
    registrationStepList: IListItem[],
    donationTypeList: IListItem[],
    stateList: IListItem[],
    countryList: IListItem[],
    donorTypeList: IListItem[],
    remissionStatusList: IListItem[],
    diabetesStatusList: IListItem[],
    yesNoUnknownList: IListItem[],
    preWorkUpLabList: IListItem[],
    connectToDonorGroupList: IListItem[],
    centerList: ICenterBase[],
    recipientCenters: IStateCenterOption[],
    dirty: boolean,
    confirm: {
        show: boolean
    },
}

class DonorDiagnosisAddEdit extends React.Component<TProps, IState> {
    readonly state: IState = {
        id: 0,
        centerId: 0,
        email: '',
        firstName: '',
        middleInitial: '',
        lastName: '',
        preferredName: '',
        donationType: 0,
        entryDomain: '',
        currentRegistrationStep: 0,
        isAcceptable: null,
        ruleOutReasons: '',
        sendReScreen: false,
        editKey: '',
        stopCommunication: false,
        connectToDonorIsDesired: false,
        connectToDonorGroup: 0,
        closeLoopSurgeryDateTime: '',
        isCurrentlyIncarcerated: false,
        isResidingInUsa: false,
        isAbleToGetToUsa: false,
        isDonatingForCompensation: false,
        willAcceptTransfusions: false,
        hasHadKidneyDisease: false,
        hasHadHeartAttack: false,
        hasDiabetes: false,
        diabetesStatus: 0,
        hasHadCancer: false,
        hasHadKidneyStones: false,
        kidneyStoneEpisodes: null,
        kidneyStoneRemissionStatus: 0,
        hasBeenPregnant: false,
        isPregnant: false,
        monthsSincePregnant: 0,
        isNursing: false,
        hadGestationalDiabetes: false,
        hasUsedTobacco: false,
        usesTobacco: false,
        willStopTobaccoUse: false,
        hasHiv: 0,
        weightLbs: 0,
        heightInches: 0,
        birthDate: '',
        addressLine1: '',
        city: '',
        state: 0,
        nonUsStateProvince: '',
        countryOfResidenceId: 1,
        postalCode: 0,
        donorSituation: 0,
        ddRecipFirstName: '',
        ddRecipLastName: '',
        ddRecipDob: '',
        preWorkupLabStep: 0,
        phoneNumber: '',
        phoneNumberSecondary: '',
        mobileAuthPhone: '',
        expireDateTime: '',
        isMobileAuthPhoneConfirmed: false,
        originalMobileAuthPhone: '',
        isConfirm: false,
        originalEmail: '',
        validation: {
            entryDomain: true,
            closeLoopSurgeryDateTime: true,
            birthDate: true,
            email: true,
            mobileAuthPhone: true
        },
        previousLocation: '',
        originalCenterId: 0,
        intendedRecipientCenter: null,
        existingList: [],
        registrationStepList: [],
        donationTypeList: [],
        stateList: [],
        countryList: [],
        donorTypeList: [],
        remissionStatusList: [],
        centerList: [],
        recipientCenters: [],
        diabetesStatusList: [],
        yesNoUnknownList: [],
        preWorkUpLabList: [],
        connectToDonorGroupList: [],
        dirty: false,
        confirm: {
            show: false
        },
    }

    componentDidMount = () => {
        let previousLocation = this.props.isAdmin ? `/admin/microsites/${this.props.previousUrl}` : `/center/${this.props.centerId}/microsites/${this.props.previousUrl}`;

        if (this.props.regId > 0) {
            this.props.showLoading('Getting the diagnostics, one moment please...').then(() => {
                Promise.all([
                    this.props.getDiagnostic(this.props.centerId, this.props.regId, this.props.isAdmin),
                    this.props.getLookupData()
                ])
                    .then(([response, lookupDataResponse]) => {
                        if (response.data.success && lookupDataResponse.data.success) {
                            let { id, centerId, email, donationType, entryDomain, currentRegistrationStep, stopCommunication, closeLoopSurgeryDateTime, isCurrentlyIncarcerated, isResidingInUsa, isAbleToGetToUsa, isDonatingForCompensation, willAcceptTransfusions,
                                hasHadKidneyDisease, hasHadHeartAttack, hasDiabetes, diabetesStatus, hasHadCancer, hasHadKidneyStones, kidneyStoneEpisodes, kidneyStoneRemissionStatus, hasBeenPregnant, isPregnant,
                                monthsSincePregnant, isNursing, hadGestationalDiabetes, hasUsedTobacco, usesTobacco, willStopTobaccoUse, hasHiv, weightLbs, heightInches, birthDate, addressLine1, city, state, nonUsStateProvince,
                                countryOfResidenceId, postalCode, donorSituation, ddRecipFirstName, ddRecipLastName, ddRecipDob, preWorkupLabStep, phoneNumber, editKey, intendedRecipientCenter, connectToDonorIsDesired, connectToDonorGroup,
                                firstName, middleInitial, lastName, preferredName, phoneNumberSecondary, mobileAuthPhone, expireDateTime, isAcceptable } = response.data.results;

                            let { stateList, countryList, centerList, registrationStepList, donationTypeList, remissionStatusList, donorTypeList, yesNoUnknownList, diabetesStatusList, preWorkUpLabList, connectToDonorGroupList, recipientCenters } = lookupDataResponse.data.results;

                            this.setState({
                                id, centerId, email, donationType, entryDomain, currentRegistrationStep, stopCommunication, closeLoopSurgeryDateTime, isCurrentlyIncarcerated, isResidingInUsa, isAbleToGetToUsa, isDonatingForCompensation, willAcceptTransfusions,
                                hasHadKidneyDisease, hasHadHeartAttack, hasDiabetes, diabetesStatus, hasHadCancer, hasHadKidneyStones, kidneyStoneEpisodes, kidneyStoneRemissionStatus, hasBeenPregnant, isPregnant,
                                monthsSincePregnant, isNursing, hadGestationalDiabetes, hasUsedTobacco, usesTobacco, willStopTobaccoUse, hasHiv, weightLbs, heightInches, birthDate, addressLine1, city, state, nonUsStateProvince,
                                countryOfResidenceId: countryOfResidenceId ?? -1,
                                connectToDonorIsDesired,
                                connectToDonorGroup,
                                editKey,
                                previousLocation,
                                phoneNumber,
                                firstName,
                                middleInitial,
                                lastName,
                                preferredName,
                                phoneNumberSecondary,
                                mobileAuthPhone,
                                originalMobileAuthPhone: mobileAuthPhone,
                                originalEmail: email,
                                expireDateTime,
                                isAcceptable,
                                postalCode,
                                donorSituation,
                                ddRecipFirstName,
                                ddRecipLastName,
                                ddRecipDob,
                                preWorkupLabStep,
                                intendedRecipientCenter: intendedRecipientCenter ?? null,
                                originalCenterId: centerId,
                                stateList,
                                countryList: countryList ?? [],
                                centerList,
                                registrationStepList,
                                donationTypeList,
                                remissionStatusList,
                                donorTypeList,
                                yesNoUnknownList,
                                diabetesStatusList,
                                preWorkUpLabList,
                                connectToDonorGroupList,
                                recipientCenters
                            });
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }
    }

    validate = async () => {
        let { entryDomain, closeLoopSurgeryDateTime, birthDate, mobileAuthPhone, originalMobileAuthPhone, isMobileAuthPhoneConfirmed, email, originalEmail, isConfirm } = this.state;

        let hundredYearsAgo = moment().subtract(100, "year");
        let closeLoopSurgeryDateTimeValid = closeLoopSurgeryDateTime != "" ? moment(closeLoopSurgeryDateTime, 'YYYY-MM-DD') > hundredYearsAgo : true;
        let birthDateValid = birthDate != "" ? moment(birthDate, 'YYYY-MM-DD').isValid() && moment(birthDate, 'YYYY-MM-DD') > hundredYearsAgo && moment(birthDate, 'YYYY-MM-DD') < moment() : true;

        // Email and the mobile auth phone are both sign-in identities, so a change to either is
        // rejected until the coordinator has confirmed it rather than being dropped on save.
        let emailChanged = (email ?? '').trim() != (originalEmail ?? '').trim();
        let emailValid = !emailChanged || isConfirm;

        // The donor signs in with this number, so it has to stay in the 10-digit form the
        // registration site stores.
        let mobileAuthPhoneChanged = (mobileAuthPhone ?? '') != (originalMobileAuthPhone ?? '');
        let mobileAuthPhoneValid = (mobileAuthPhone ? /^\d{10}$/.test(mobileAuthPhone) : true)
            && (!mobileAuthPhoneChanged || isMobileAuthPhoneConfirmed);

        let validation: IValidation = {
            entryDomain: entryDomain != '',
            closeLoopSurgeryDateTime: closeLoopSurgeryDateTimeValid,
            birthDate: birthDateValid,
            email: emailValid,
            mobileAuthPhone: mobileAuthPhoneValid
        };

        return { validation };
    }

    isValid = () => {
        let { entryDomain, closeLoopSurgeryDateTime, birthDate, email, mobileAuthPhone } = this.state.validation;

        return entryDomain && closeLoopSurgeryDateTime && birthDate && email && mobileAuthPhone;
    }

    handleFieldChange = (e: React.ChangeEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;
        let state = _.cloneDeep(this.state);

        state[name] = value != '' ? parseInt(value) : null;

        this.setState(state);
    }

    handleSelectChange = (e: React.ChangeEvent<FormControl & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;
        let state = _.cloneDeep(this.state);

        state[name] = parseInt(value);

        this.setState(state);
    }

    handleTextChange = (e: React.ChangeEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;
        let state = _.cloneDeep(this.state);

        state[name] = value;

        this.setState(state);
    }

    handleConfirmEmailChange = (value: boolean) => {
        this.setState({
            isConfirm: !this.state.isConfirm
        });
    }

    handleConfirmMobileAuthPhoneChange = () => {
        this.setState({
            isMobileAuthPhoneConfirmed: !this.state.isMobileAuthPhoneConfirmed
        });
    }

    handleCancelReScreen = () => {
        this.setState({
            confirm: {
                show: false
            }
        });
    }

    handleShowReScreenConfirm = () => {
        this.setState({
            confirm: {
                show: true
            }
        });
    }

    handleSendReScreen = () => {
        this.setState({
            sendReScreen: true
        }, () => {

            let { id, centerId, email, donationType, entryDomain, currentRegistrationStep, stopCommunication, closeLoopSurgeryDateTime, isCurrentlyIncarcerated, isResidingInUsa, isAbleToGetToUsa, isDonatingForCompensation, willAcceptTransfusions,
                hasHadKidneyDisease, hasHadHeartAttack, hasDiabetes, diabetesStatus, hasHadCancer, hasHadKidneyStones, kidneyStoneEpisodes, kidneyStoneRemissionStatus, hasBeenPregnant, isPregnant,
                monthsSincePregnant, isNursing, hadGestationalDiabetes, hasUsedTobacco, usesTobacco, willStopTobaccoUse, hasHiv, weightLbs, heightInches, birthDate, addressLine1, city, state, nonUsStateProvince,
                countryOfResidenceId, postalCode, donorSituation, ddRecipFirstName, ddRecipLastName, ddRecipDob, preWorkupLabStep, isConfirm, sendReScreen, intendedRecipientCenter, editKey, connectToDonorGroup,
                firstName, middleInitial, lastName, preferredName, phoneNumber, phoneNumberSecondary, mobileAuthPhone, isMobileAuthPhoneConfirmed, expireDateTime, isAcceptable
            } = this.state;

            email = email.trim();

            let request: IDonorDiagnosticRequest = {
                id, centerId, email, donationType, entryDomain, currentRegistrationStep, stopCommunication, closeLoopSurgeryDateTime, isCurrentlyIncarcerated, isResidingInUsa, isAbleToGetToUsa, isDonatingForCompensation, willAcceptTransfusions,
                hasHadKidneyDisease, hasHadHeartAttack, hasDiabetes, diabetesStatus, hasHadCancer, hasHadKidneyStones, kidneyStoneEpisodes, kidneyStoneRemissionStatus, hasBeenPregnant, isPregnant,
                monthsSincePregnant, isNursing, hadGestationalDiabetes, hasUsedTobacco, usesTobacco, willStopTobaccoUse, hasHiv, weightLbs, heightInches, birthDate, addressLine1, city, state, nonUsStateProvince,
                countryOfResidenceId: countryOfResidenceId != null && countryOfResidenceId > 0 ? countryOfResidenceId : null, postalCode, donorSituation, ddRecipFirstName, ddRecipLastName, ddRecipDob, preWorkupLabStep, isConfirm, sendReScreen, intendedRecipientCenter, editKey, connectToDonorGroup,
                firstName, middleInitial, lastName, preferredName, phoneNumber, phoneNumberSecondary, mobileAuthPhone, isMobileAuthPhoneConfirmed, expireDateTime, isAcceptable
            };

            this.props.showLoading('Saving and reruning screening...').then(() => {
                this.props.saveDiagnostic(request)
                    .then(response => {
                        if (response.data.success) {
                            this.setState({
                                confirm: {
                                    show: false
                                }
                            })

                            if (currentRegistrationStep == DashRegistrationStep.AutoRuledOut || currentRegistrationStep == DashRegistrationStep.TempRuleOut) {
                                window.location.href = 'http://' + entryDomain + '/register/send-acceptance/' + id + '/' + editKey + '';
                            }

                            toast.success('Diagnostic saved successfully');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleOptInToMentor = () => {
        this.props.showLoading('Opting in to a donor mentor, one moment please...').then(() => {
            this.props.optInToMentor(this.state.id)
                .then(response => {
                    if (response.data.success) {
                        this.setState({ connectToDonorIsDesired: true });
                        toast.success('Donor mentor opt-in saved successfully');
                    } else {
                        toast.error('Could not opt in to a donor mentor: ' + response.data.message);
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleSave = async () => {
        let { validation } = await this.validate();

        this.setState({
            validation,
            dirty: true
        }, () => {
            let isValid = this.isValid() && this.state.existingList.length == 0;

            if (!isValid) {
                window.scrollTo(0, 0);
            } else {
                let { id, centerId, email, donationType, entryDomain, currentRegistrationStep, stopCommunication, closeLoopSurgeryDateTime, isCurrentlyIncarcerated, isResidingInUsa, isAbleToGetToUsa, isDonatingForCompensation, willAcceptTransfusions,
                    hasHadKidneyDisease, hasHadHeartAttack, hasDiabetes, diabetesStatus, hasHadCancer, hasHadKidneyStones, kidneyStoneEpisodes, kidneyStoneRemissionStatus, hasBeenPregnant, isPregnant,
                    monthsSincePregnant, isNursing, hadGestationalDiabetes, hasUsedTobacco, usesTobacco, willStopTobaccoUse, hasHiv, weightLbs, heightInches, birthDate, addressLine1, city, state, nonUsStateProvince,
                    countryOfResidenceId, postalCode, donorSituation, ddRecipFirstName, ddRecipLastName, ddRecipDob, preWorkupLabStep, isConfirm, sendReScreen, intendedRecipientCenter, editKey, connectToDonorGroup,
                    firstName, middleInitial, lastName, preferredName, phoneNumber, phoneNumberSecondary, mobileAuthPhone, isMobileAuthPhoneConfirmed, expireDateTime, isAcceptable
                } = this.state;

                email = email.trim();

                let request: IDonorDiagnosticRequest = {
                    id, centerId, email, donationType, entryDomain, currentRegistrationStep, stopCommunication, closeLoopSurgeryDateTime, isCurrentlyIncarcerated, isResidingInUsa, isAbleToGetToUsa, isDonatingForCompensation, willAcceptTransfusions,
                    hasHadKidneyDisease, hasHadHeartAttack, hasDiabetes, diabetesStatus, hasHadCancer, hasHadKidneyStones, kidneyStoneEpisodes, kidneyStoneRemissionStatus, hasBeenPregnant, isPregnant,
                    monthsSincePregnant, isNursing, hadGestationalDiabetes, hasUsedTobacco, usesTobacco, willStopTobaccoUse, hasHiv, weightLbs, heightInches, birthDate, addressLine1, city, state, nonUsStateProvince,
                    countryOfResidenceId: countryOfResidenceId != null && countryOfResidenceId > 0 ? countryOfResidenceId : null, postalCode, donorSituation, ddRecipFirstName, ddRecipLastName, ddRecipDob, preWorkupLabStep, isConfirm, sendReScreen, intendedRecipientCenter, editKey, connectToDonorGroup,
                    firstName, middleInitial, lastName, preferredName, phoneNumber, phoneNumberSecondary, mobileAuthPhone, isMobileAuthPhoneConfirmed, expireDateTime, isAcceptable
                };

                this.props.showLoading('Saving donor diagnostic, one moment please...').then(() => {
                    this.props.saveDiagnostic(request)
                        .then(response => {
                            if (response.data.success) {
                                // Each change needs its own sign-off, so the saved values become
                                // the new baseline and both confirmation boxes clear.
                                this.setState({
                                    originalMobileAuthPhone: mobileAuthPhone,
                                    isMobileAuthPhoneConfirmed: false,
                                    originalEmail: email,
                                    isConfirm: false
                                });

                                toast.success('Diagnostic saved successfully', {
                                    onClose: () => {
                                    }
                                });
                            }
                        })
                        .finally(() => {
                            this.props.hideLoading();
                        });
                });
            }
        });
    }

    render = () => {
        let pwlLocation = this.props.isAdmin ? `/admin/dash/donor-intake/pwl/details/${this.props.regId}` : `/center/${this.props.centerId}/donors/donor-intake/pwl/details/${this.props.regId}`;
        let groupedRecipientCenters = this.state.recipientCenters?.reduce((groups, center) => {
            let currentGroup = groups[groups.length - 1];

            if (!currentGroup || currentGroup.state !== center.state) {
                currentGroup = {
                    state: center.state,
                    centers: [] as IStateCenterOption[]
                };

                groups.push(currentGroup);
            }

            currentGroup.centers.push(center);

            return groups;
        }, [] as Array<{ state: string, centers: IStateCenterOption[] }>) ?? [];

        return (
            <>
                <div className='container' style={{ paddingTop: 20 }}>
                    <DiagnosticsFormWrapper horizontal>
                        <Row>
                            <Col xs={12} lg={12}>
                                <PanelGroup>
                                    <Panel bsStyle='info'>
                                        <Panel.Heading>Diagnostic Details (General)</Panel.Heading>
                                        <Panel.Body>
                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='entryDomain'> Entry Domain: <span className='label label-danger'>WARNING: Dangerous Setting</span></Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name='entryDomain' onChange={this.handleTextChange} value={this.state.entryDomain} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='currentRegistrationStep'> Registration Step: <span className='label label-danger'>WARNING: Dangerous Setting</span></Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='currentRegistrationStep'
                                                        value={this.state.currentRegistrationStep}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        <option value={-1}>- Please Select -</option>
                                                        {this.state.registrationStepList.map((item, index) =>
                                                            <option key={'reg-1-' + index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='isAcceptable'> Is Acceptable: <span className='label label-danger'>WARNING: Dangerous Setting</span></Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='isAcceptable' name="isAcceptable" inline value={1} checked={this.state.isAcceptable == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='isAcceptable' name="isAcceptable" inline value={0} checked={this.state.isAcceptable == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='isAcceptable' name="isAcceptable" inline value={null} checked={this.state.isAcceptable == null} onChange={this.handleFieldChange}>Pending Screening</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            {this.state.preWorkupLabStep != 0 && (
                                                <FormGroup>
                                                    <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='currentRegistrationStep'> Preworkup Lab Step: <span className='label label-danger'>WARNING: Dangerous Setting</span></Col>
                                                    <Col xs={12} lg={4}>
                                                        <FormControl
                                                            componentClass='select'
                                                            name='preWorkupLabStep'
                                                            value={this.state.preWorkupLabStep}
                                                            onChange={this.handleSelectChange}
                                                        >
                                                            <option value={-1}>- Please Select -</option>
                                                            {this.state.preWorkUpLabList.map((item, index) =>
                                                                <option key={'pre-1-' + index} value={item.id}>{item.description}</option>
                                                            )}
                                                        </FormControl>
                                                    </Col>
                                                </FormGroup>
                                            )}

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='email'> Email: {this.state.validation.email == false && <span className='label label-danger'>Error: The change must be confirmed below</span>}</Col>
                                                <Col xs={12} lg={6}>
                                                    <InputGroup>
                                                        <FormControl name='email' onChange={this.handleTextChange} value={this.state.email} />
                                                        <input type='checkbox' id='sendEmail' name='sendEmail' onClick={() => this.handleConfirmEmailChange(this.state.isConfirm)} value={this.state.isConfirm ? 1 : 0} checked={this.state.isConfirm} /> I have changed the e-mail and confirm that I have used the registered e-mail or phone number to verify the change is valid with the original registrant.
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='mobileAuthPhone'> Mobile Phone: {this.state.validation.mobileAuthPhone == false && <span className='label label-danger'>Error: Must be 10 digits and confirmed below</span>}</Col>
                                                <Col xs={12} lg={6}>
                                                    <InputGroup>
                                                        <FormControl name='mobileAuthPhone' maxLength={10} onChange={this.handleTextChange} value={this.state.mobileAuthPhone} />
                                                        <input type='checkbox' id='confirmMobileAuthPhone' name='confirmMobileAuthPhone' onClick={this.handleConfirmMobileAuthPhoneChange} value={this.state.isMobileAuthPhoneConfirmed ? 1 : 0} checked={this.state.isMobileAuthPhoneConfirmed} /> I have changed the mobile phone and confirm that I have used the registered e-mail or phone number to verify the change is valid with the original registrant.
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='expireDateTime'> Expiration:</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        type='datetime-local'
                                                        min='1900-01-01T00:00'
                                                        max='9999-01-01T00:00'
                                                        name='expireDateTime'
                                                        value={this.state.expireDateTime ? moment(this.state.expireDateTime).format('YYYY-MM-DDTHH:mm') : ''}
                                                        onChange={this.handleTextChange}
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='intendedRecipientCenter'> Intended Recipient Center:</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='intendedRecipientCenter'
                                                        value={this.state.intendedRecipientCenter}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        <option value={null}>- Please Select -</option>
                                                        {groupedRecipientCenters.map((group, groupIndex) =>
                                                            <optgroup key={'cent-group-' + groupIndex} label={group.state}>
                                                                {group.centers.map((item, index) =>
                                                                    <option key={`cent-${groupIndex}-${index}`} value={item.id}>{item.alias} - {item.name}</option>
                                                                )}
                                                            </optgroup>
                                                        )}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='donationType'> Donation Type:</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='donationType'
                                                        value={this.state.donationType}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        <option value={-1}>- Please Select -</option>
                                                        {this.state.donationTypeList.map((item, index) =>
                                                            <option key={'don-1-' + index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel}>Closed Loop Surgery Date: {this.state.validation.closeLoopSurgeryDateTime == false && <span className='label label-danger'>Error: Invalid date</span>}</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        type='date'
                                                        min='1900-01-01'
                                                        max='9999-01-01'
                                                        name='closeLoopSurgeryDateTime'
                                                        value={this.state.closeLoopSurgeryDateTime ? moment(this.state.closeLoopSurgeryDateTime).format('YYYY-MM-DD') : ''}
                                                        onChange={this.handleTextChange}
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel}> Links:</Col>
                                                <Col xs={12} lg={4}>
                                                    <div className='form-control-static'>
                                                        <div><a href={`center/${this.props.centerId}/donors/donor-intake/details/${this.props.regId}`}>Donor Intake Details</a></div>
                                                        <div><a href={pwlLocation}>PWL Info</a></div>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='stopCommunication'>Is Opted-Out:</Col>
                                                <Col xs={12} lg={4}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <div>
                                                            <Radio id='stopCommunication' name="stopCommunication" inline value={1} checked={this.state.stopCommunication == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                            <Radio id='stopCommunication' name="stopCommunication" inline value={0} checked={this.state.stopCommunication == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='optInToMentor'>Opt-In to Mentor:</Col>
                                                <Col xs={12} lg={4}>
                                                    {this.state.connectToDonorIsDesired
                                                        ? <div className='form-control-static'>Opted In</div>
                                                        : <Button id='optInToMentor' bsStyle='primary' onClick={this.handleOptInToMentor}>Opt-In to Mentor</Button>
                                                    }
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='connectToDonorGroup'>Mentor Group:</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='connectToDonorGroup'
                                                        value={this.state.connectToDonorGroup}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        {this.state.connectToDonorGroupList.map((item, index) =>
                                                            <option key={'ctdg-1-' + index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>
                                        </Panel.Body>
                                    </Panel>

                                    <Panel bsStyle='success'>
                                        <Panel.Heading>Donor Candidate's Screening Details</Panel.Heading>
                                        <Panel.Body>
                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='isCurrentlyIncarcerated'>Is Currently Incarcerated?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='isCurrentlyIncarcerated' name="isCurrentlyIncarcerated" inline value={1} checked={this.state.isCurrentlyIncarcerated == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='isCurrentlyIncarcerated' name="isCurrentlyIncarcerated" inline value={0} checked={this.state.isCurrentlyIncarcerated == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='isCurrentlyIncarcerated' name="isCurrentlyIncarcerated" inline value={null} checked={this.state.isCurrentlyIncarcerated == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='isResidingInUsa'>Is Residing in USA?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='isResidingInUsa' name="isResidingInUsa" inline value={1} checked={this.state.isResidingInUsa == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='isResidingInUsa' name="isResidingInUsa" inline value={0} checked={this.state.isResidingInUsa == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='isResidingInUsa' name="isResidingInUsa" inline value={null} checked={this.state.isResidingInUsa == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='isAbleToGetToUsa'>Is Able to get to USA?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='isAbleToGetToUsa' name="isAbleToGetToUsa" inline value={1} checked={this.state.isAbleToGetToUsa == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='isAbleToGetToUsa' name="isAbleToGetToUsa" inline value={0} checked={this.state.isAbleToGetToUsa == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='isAbleToGetToUsa' name="isAbleToGetToUsa" inline value={null} checked={this.state.isAbleToGetToUsa == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='isDonatingForCompensation'>Is Donating for Compensation?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='isDonatingForCompensation' name="isDonatingForCompensation" inline value={1} checked={this.state.isDonatingForCompensation == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='isDonatingForCompensation' name="isDonatingForCompensation" inline value={0} checked={this.state.isDonatingForCompensation == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='isDonatingForCompensation' name="isDonatingForCompensation" inline value={null} checked={this.state.isDonatingForCompensation == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>


                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='willAcceptTransfusions'>Will Accept Blood Transfusions?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='willAcceptTransfusions' name="willAcceptTransfusions" inline value={1} checked={this.state.willAcceptTransfusions == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='willAcceptTransfusions' name="willAcceptTransfusions" inline value={0} checked={this.state.willAcceptTransfusions == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='willAcceptTransfusions' name="willAcceptTransfusions" inline value={null} checked={this.state.willAcceptTransfusions == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='hasHadKidneyDisease'>Has been Diagnosed with Kidney Disease?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='hasHadKidneyDisease' name="hasHadKidneyDisease" inline value={1} checked={this.state.hasHadKidneyDisease == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='hasHadKidneyDisease' name="hasHadKidneyDisease" inline value={0} checked={this.state.hasHadKidneyDisease == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='hasHadKidneyDisease' name="hasHadKidneyDisease" inline value={null} checked={this.state.hasHadKidneyDisease == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='hasHadHeartAttack'>Has had a Heart Attack?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='hasHadHeartAttack' name="hasHadHeartAttack" inline value={1} checked={this.state.hasHadHeartAttack == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='hasHadHeartAttack' name="hasHadHeartAttack" inline value={0} checked={this.state.hasHadHeartAttack == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='hasHadHeartAttack' name="hasHadHeartAttack" inline value={null} checked={this.state.hasHadHeartAttack == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='hasDiabetes'>Has Diabetes?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='hasDiabetes' name="hasDiabetes" inline value={1} checked={this.state.hasDiabetes == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='hasDiabetes' name="hasDiabetes" inline value={0} checked={this.state.hasDiabetes == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='hasDiabetes' name="hasDiabetes" inline value={null} checked={this.state.hasDiabetes == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='diabetesStatus'> &nbsp; - BG maintained by:</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='diabetesStatus'
                                                        value={this.state.diabetesStatus}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        <option value={-1}>- Please Select -</option>
                                                        {this.state.diabetesStatusList.map((item, index) =>
                                                            <option key={'don-1-' + index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='hasHadCancer'>Has had Cancer?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='hasHadCancer' name="hasHadCancer" inline value={1} checked={this.state.hasHadCancer == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='hasHadCancer' name="hasHadCancer" inline value={0} checked={this.state.hasHadCancer == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='hasHadCancer' name="hasHadCancer" inline value={null} checked={this.state.hasHadCancer == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='hasHadKidneyStones'>Has had Kidney Stones?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='hasHadKidneyStones' name="hasHadKidneyStones" inline value={1} checked={this.state.hasHadKidneyStones == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='hasHadKidneyStones' name="hasHadKidneyStones" inline value={0} checked={this.state.hasHadKidneyStones == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='hasHadKidneyStones' name="hasHadKidneyStones" inline value={null} checked={this.state.hasHadKidneyStones == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='kidneyStoneEpisodes'> &nbsp; - number of episodes?</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl name="kidneyStoneEpisodes" onChange={this.handleTextChange} value={this.state.kidneyStoneEpisodes} />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='kidneyStoneRemissionStatus'> &nbsp; - last stones passed?</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='kidneyStoneRemissionStatus'
                                                        value={this.state.kidneyStoneRemissionStatus}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        <option value={-1}>- Please Select -</option>
                                                        {this.state.remissionStatusList.map((item, index) =>
                                                            <option key={'lst-stone-status-1-' + index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='hasBeenPregnant'>Has ever been Pregnant?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='hasBeenPregnant' name="hasBeenPregnant" inline value={1} checked={this.state.hasBeenPregnant == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='hasBeenPregnant' name="hasBeenPregnant" inline value={0} checked={this.state.hasBeenPregnant == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='hasBeenPregnant' name="hasBeenPregnant" inline value={null} checked={this.state.hasBeenPregnant == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='isPregnant'>&nbsp; - Is Currently Pregnant?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='isPregnant' name="isPregnant" inline value={1} checked={this.state.isPregnant == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='isPregnant' name="isPregnant" inline value={0} checked={this.state.isPregnant == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='isPregnant' name="isPregnant" inline value={null} checked={this.state.isPregnant == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='monthsSincePregnant'> &nbsp; - Months since pregnant</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="monthsSincePregnant" onChange={this.handleTextChange} value={this.state.monthsSincePregnant} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='isNursing'>&nbsp; - Is Currently Nursing?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='isNursing' name="isNursing" inline value={1} checked={this.state.isNursing == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='isNursing' name="isNursing" inline value={0} checked={this.state.isNursing == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='isNursing' name="isNursing" inline value={null} checked={this.state.isNursing == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='hadGestationalDiabetes'>&nbsp;  - Gestational Diabetes?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='hadGestationalDiabetes' name="hadGestationalDiabetes" inline value={1} checked={this.state.hadGestationalDiabetes == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='hadGestationalDiabetes' name="hadGestationalDiabetes" inline value={0} checked={this.state.hadGestationalDiabetes == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='hadGestationalDiabetes' name="hadGestationalDiabetes" inline value={null} checked={this.state.hadGestationalDiabetes == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='hasUsedTobacco'>Has Used Tobacco</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='hasUsedTobacco' name="hasUsedTobacco" inline value={1} checked={this.state.hasUsedTobacco == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='hasUsedTobacco' name="hasUsedTobacco" inline value={0} checked={this.state.hasUsedTobacco == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='hasUsedTobacco' name="hasUsedTobacco" inline value={null} checked={this.state.hasUsedTobacco == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='usesTobacco'>&nbsp;  - Currently uses Tobacco?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='usesTobacco' name="usesTobacco" inline value={1} checked={this.state.usesTobacco == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='usesTobacco' name="usesTobacco" inline value={0} checked={this.state.usesTobacco == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='usesTobacco' name="usesTobacco" inline value={null} checked={this.state.usesTobacco == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='willStopTobaccoUse'>&nbsp;  - Will Stop for Surgery?</Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <Radio id='willStopTobaccoUse' name="willStopTobaccoUse" inline value={1} checked={this.state.willStopTobaccoUse == true} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                                        <Radio id='willStopTobaccoUse' name="willStopTobaccoUse" inline value={0} checked={this.state.willStopTobaccoUse == false} onChange={this.handleFieldChange}>No</Radio>{' '}
                                                        <Radio id='willStopTobaccoUse' name="willStopTobaccoUse" inline value={null} checked={this.state.willStopTobaccoUse == null} onChange={this.handleFieldChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='hasHiv'> Has HIV?</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='hasHiv'
                                                        value={this.state.hasHiv}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        {this.state.yesNoUnknownList.map((item, index) =>
                                                            <option key={'yes-no-status-1-' + index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='weightLbs'> Weight (lbs)</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="weightLbs" onChange={this.handleTextChange} value={this.state.weightLbs} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='heightInches'> Height (total inches)</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="heightInches" onChange={this.handleTextChange} value={this.state.heightInches} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='birthDate'> Birthdate: {this.state.validation.birthDate == false && <span className='label label-danger'>Error: Invalid date</span>}</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl
                                                            type='date'
                                                            min='1900-01-01'
                                                            max='9999-01-01'
                                                            name='birthDate'
                                                            value={this.state.birthDate ? moment(this.state.birthDate).format('YYYY-MM-DD') : ''}
                                                            onChange={this.handleTextChange}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>
                                        </Panel.Body>
                                    </Panel>

                                    <Panel bsStyle='warning'>
                                        <Panel.Heading>Additional Donor Candidate Details</Panel.Heading>
                                        <Panel.Body>
                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='firstName'> First Name:</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="firstName" onChange={this.handleTextChange} value={this.state.firstName} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='middleInitial'> Middle Initial:</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="middleInitial" maxLength={1} onChange={this.handleTextChange} value={this.state.middleInitial} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='lastName'> Last Name:</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="lastName" onChange={this.handleTextChange} value={this.state.lastName} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='preferredName'> Preferred Name:</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="preferredName" onChange={this.handleTextChange} value={this.state.preferredName} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='countryOfResidenceId'>Country of Residence:</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='countryOfResidenceId'
                                                        value={this.state.countryOfResidenceId ?? -1}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        <option value={-1}>- Please Select -</option>
                                                        {this.state.countryList.map((item, index) =>
                                                            <option key={'country-' + index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='addressLine1'> Address:</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="addressLine1" onChange={this.handleTextChange} value={this.state.addressLine1} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='city'> City:</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="city" onChange={this.handleTextChange} value={this.state.city} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='state'> State:</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='state'
                                                        value={this.state.state}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        <option value={-1}>- Please Select -</option>
                                                        {this.state.stateList.map((item, index) =>
                                                            <option key={'state-1-' + index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='postalCode'> Postal Code:</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="postalCode" onChange={this.handleTextChange} value={this.state.postalCode} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='phoneNumber'> Primary Phone:</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="phoneNumber" onChange={this.handleTextChange} value={this.state.phoneNumber} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='phoneNumberSecondary'> Secondary Phone:</Col>
                                                <Col xs={12} lg={4}>
                                                    <InputGroup style={{ width: '100%' }}>
                                                        <FormControl name="phoneNumberSecondary" onChange={this.handleTextChange} value={this.state.phoneNumberSecondary} />
                                                    </InputGroup>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup>
                                                <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='donorSituation'> Donor Type?</Col>
                                                <Col xs={12} lg={4}>
                                                    <FormControl
                                                        componentClass='select'
                                                        name='donorSituation'
                                                        value={this.state.donorSituation}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        <option value={-1}>- Please Select -</option>
                                                        {this.state.donorTypeList.map((item, index) =>
                                                            <option key={'lst-donor-type-1-' + index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>
                                        </Panel.Body>
                                    </Panel>

                                    {this.state.donorSituation == 1 && (
                                        <Panel bsStyle='info'>
                                            <Panel.Heading>Directed Donor Details</Panel.Heading>
                                            <Panel.Body>
                                                <FormGroup>
                                                    <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='ddRecipFirstName'> Recipient First Name:</Col>
                                                    <Col xs={12} lg={4}>
                                                        <InputGroup style={{ width: '100%' }}>
                                                            <FormControl name="ddRecipFirstName" onChange={this.handleTextChange} value={this.state.ddRecipFirstName} />
                                                        </InputGroup>
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup>
                                                    <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='ddRecipLastName'> Recipient Last Name:</Col>
                                                    <Col xs={12} lg={4}>
                                                        <InputGroup style={{ width: '100%' }}>
                                                            <FormControl name="ddRecipLastName" onChange={this.handleTextChange} value={this.state.ddRecipLastName} />
                                                        </InputGroup>
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup>
                                                    <Col xs={12} lg={4} lgOffset={2} componentClass={ControlLabel} htmlFor='ddRecipDob'> Recipient Birthdate:</Col>
                                                    <Col xs={12} lg={4}>
                                                        <InputGroup style={{ width: '100%' }}>
                                                            <FormControl
                                                                type='date'
                                                                min='1900-01-01'
                                                                max='9999-01-01'
                                                                name='ddRecipDob'
                                                                value={this.state.ddRecipDob ? moment(this.state.ddRecipDob).format('YYYY-MM-DD') : ''}
                                                                onChange={this.handleTextChange}
                                                            />
                                                        </InputGroup>
                                                    </Col>
                                                </FormGroup>

                                            </Panel.Body>
                                        </Panel>
                                    )}
                                </PanelGroup>

                                <FormGroup style={{ marginTop: 20 }}>
                                    <Col xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Button bsStyle='primary' bsSize='lg' className='col-xs-2' style={{ marginRight: 5 }} onClick={this.handleSave}>Save</Button>
                                        <Button bsStyle='warning' bsSize='lg' onClick={this.handleShowReScreenConfirm}>Save & Rerun Screening</Button>
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row >
                    </DiagnosticsFormWrapper>
                </div>

                <ConfirmRuleOut
                    show={this.state.confirm.show}
                    onSendReScreen={this.handleSendReScreen}
                    onCancel={this.handleCancelReScreen}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getDiagnostic: (centerId, registrationId, isAdmin) => {
            return dispatch(DashCenterActionCreators.getDiagnostic(centerId, registrationId, isAdmin));
        },
        getLookupData: () => {
            return dispatch(DashCenterActionCreators.getLookupData());
        },
        saveDiagnostic: (request) => {
            return dispatch(DashCenterActionCreators.saveDiagnostic(request));
        },
        optInToMentor: (registrationId) => {
            return dispatch(DashCenterActionCreators.optInToMentor(registrationId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorDiagnosisAddEdit);